module.exports = __webpack_public_path__ + "img/flower_leaf_33.fc6c6866.png";